import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { FieldType } from '@ngx-formly/core';

@Component({
    selector: 'formly-field-radio-description',
    template: `
    <div class="mb-3">
      <label [ngClass]="to['compact'] ? 'form-label d-block small mb-1 fw-semibold' : 'form-label d-block'">{{ to.label }}</label>

      <div [ngClass]="to['inline'] ? 'd-flex gap-2' : 'd-flex flex-column gap-2'">
        <div
          *ngFor="let option of radioOptions"
          [ngClass]="{
            'flex-fill': to['inline'],
            'border-primary': control.value === option.value,
            'selected': control.value === option.value,
            'border-danger': showError && !control.value
          }"
          class="card radio-card"
          (click)="selectOption(option.value)"
          style="cursor: pointer;"
        >
          <div [ngClass]="to['compact'] ? 'card-body d-flex align-items-start p-2' : 'card-body d-flex align-items-start'">
            <div [ngClass]="to['compact'] ? 'form-check me-1  ' : 'form-check me-2'">
              <input
                [ngClass]="to['compact'] ? 'form-check-input form-check-input-sm' : 'form-check-input'"
                type="radio"
                [id]="id + '_' + option.value"
                [value]="option.value"
                [name]="id"
                [formControl]="control"
                [formlyAttributes]="field"
                [attr.tabindex]="-1"
              />
            </div>
            <div class="flex-grow-1">
              <label
                [ngClass]="to['compact'] ? 'form-check-label small lh-sm' : 'form-check-label'"
                [for]="id + '_' + option.value"
                style="cursor: pointer;"
              >
                <span class="fw-medium">{{ option.label }}</span>
              </label>
              <p
                *ngIf="option.description"
                [ngClass]="to['compact'] ? 'text-muted mb-0 lh-sm' : 'text-muted mb-0'"
                style="font-size: 0.75rem;"
              >{{ option.description }}</p>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="showError" class="text-danger small mt-1">
        <formly-validation-message [field]="field"></formly-validation-message>
      </div>
    </div>
  `,
    styles: [`
    .radio-card {
      transition: all 0.2s ease;
      min-width: 0;
    }
    .radio-card:hover {
      box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.1);
      transform: translateY(-2px);
    }
    .radio-card.selected {
      background-color: rgba(var(--bs-primary-rgb), 0.05);
    }
    .form-check-input {
      border-radius: 100% !important;
      border-color: black !important;
    }
    .form-check-input-sm {
      width: 1rem !important;
      height: 1rem !important;
      margin-top: 0.2rem !important;

    }
    :host-context(.compact-radio) .form-check-input {
      width: 0.8rem;
      height: 0.8rem;
    }
    .flex-fill {
      min-width: 0;
    }
  `],
    standalone: false
})
export class CustomRadioDescriptionType extends FieldType implements OnInit {
  ngOnInit(): void {
    if (this.props.required) {
      this.formControl.addValidators(Validators.required);
      this.formControl.updateValueAndValidity({ emitEvent: false });
    }
  }

  get radioOptions() {
    return this.to.options as any[];
  }

  get control(): FormControl {
    return this.formControl as FormControl ?? null;
  }

  selectOption(value: any): void {
    this.control.setValue(value);
    this.control.markAsTouched();
  }
}
